module.exports = __webpack_public_path__ + "img/step-three.21ec3e14.png";